import { Component } from '@angular/core';
import { Observable } from "rxjs";
import { AuthenticationService } from "@/core/services/authentication.service";
import { MenuItem, SidebarMenuItems } from '@/core/components/sidebar/menu-items';

@Component({
  selector: 'cosmos-root-layout',
  templateUrl: './root-layout.component.html',
  styleUrls: ['./root-layout.component.scss'],
})
export class RootLayoutComponent {

  public readonly _isLoggedIn$: Observable<boolean>;
  public readonly _items: MenuItem[] = SidebarMenuItems;

  public constructor(
    private readonly _authenticationService: AuthenticationService,
  ) {
    this._isLoggedIn$ = this._authenticationService.loggedIn$;
  }
}
